import type {VehicleStoredVehiclesSummary} from "../types";

export type StoredTrackingLabel = "Active" | "Eligible" | "None";

export type StoredTrackingBadgeVariant = "success" | "secondary" | "warning";

function isStoredTrackingActiveFlag(active: VehicleStoredVehiclesSummary["active"]): boolean {
  return active === true || active === 1 || active === "1" || active === "tracking";
}

function isPastOrEqualCiteEligibleAt(at: string | null | undefined, nowMs: number): boolean {
  const raw = at?.trim();
  if (!raw) return false;
  const t = Date.parse(raw);
  if (Number.isNaN(t)) return false;
  return nowMs >= t;
}

/** List / summary display for `vehicle.stored_vehicles` (Parking Enforcement table). */
export function getVehicleStoredTrackingDisplay(
  sv: VehicleStoredVehiclesSummary | null | undefined,
  nowMs: number = Date.now(),
): {label: StoredTrackingLabel; variant: StoredTrackingBadgeVariant} {
  if (!sv) return {label: "None", variant: "secondary"};
  if (isStoredTrackingActiveFlag(sv.active)) return {label: "Active", variant: "success"};
  if (sv.active === "eligible") return {label: "Eligible", variant: "warning"};
  if (isPastOrEqualCiteEligibleAt(sv.cite_eligible_at, nowMs)) return {label: "Eligible", variant: "warning"};
  return {label: "None", variant: "secondary"};
}
